import script from "./TrainingUploadView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingUploadView.vue?vue&type=script&setup=true&lang=js"

import "./TrainingUploadView.vue?vue&type=style&index=0&id=487e35c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487e35c9"]])

export default __exports__